import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs, isPlatform,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { ellipse, square, triangle } from 'ionicons/icons';
import Tab1 from './pages/Tab1';
import Tab2 from './pages/Tab2';
import Tab3 from './pages/Tab3';
import pkg_data from '../package.json';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import {StatusBar, Style} from "@capacitor/status-bar";
import {Keyboard} from "@capacitor/keyboard";

setupIonicReact({
  statusTap: true,
});

export const isIOS = isPlatform('ios') || isPlatform('iphone') || isPlatform('ipad');
export const isIOSApp = isIOS && !isPlatform('mobileweb');

if (isPlatform('capacitor')) {
  StatusBar.setStyle({ style: Style.Dark });
  Keyboard.setAccessoryBarVisible({ isVisible: true });
}

export const iOSVersion = (): string => {
  let vText = '999_999_999';
  const uAgent = navigator.userAgent;
  let wkTexts = uAgent.split('CPU iPhone OS ');
  if (wkTexts && wkTexts.length > 1) {
    // iPhone mobile site
    let wkText = wkTexts[1];
    vText = wkText.split(' ')[0];
  } else if (uAgent.indexOf('iPad; CPU OS') > -1) {
    // iPad mobile site
    wkTexts = uAgent.split('iPad; CPU OS ');
    if (wkTexts && wkTexts.length > 1) {
      let wkText = wkTexts[1];
      vText = wkText.split(' ')[0];
    }
  } else if (uAgent.indexOf('Intel Mac OS X') > -1) {
    // iPhone or iPad desktop site
    wkTexts = uAgent.split('Version/');
    if (wkTexts && wkTexts.length > 1) {
      let wkText = wkTexts[1];
      vText = wkText.split(' ')[0];
    }
  }
  return vText;
};

export const WebKitVersion = (): string => {
  let wkText = navigator.userAgent.split('AppleWebKit/')[1];
  let vText = wkText.split(' ')[0];
  // if(/iP(hone|od|ad)/.test(navigator.platform) {
  //
  // }
  return vText;
};

const App: React.FC = () => (
  <IonApp>
    {/*<IonReactRouter>*/}
    <IonReactRouter basename={pkg_data.homepage}>
      <IonTabs>
        <IonRouterOutlet>
          <Route exact path="/tab1">
            <Tab1 />
          </Route>
          <Route exact path="/tab2">
            <Tab2 />
          </Route>
          <Route path="/tab3">
            <Tab3 />
          </Route>
          <Route exact path="/">
            <Redirect to="/tab1" />
          </Route>
        </IonRouterOutlet>
        <IonTabBar slot="bottom">
          <IonTabButton tab="tab1" href="/tab1">
            <IonIcon aria-hidden="true" icon={triangle} />
            <IonLabel>Tab 1</IonLabel>
          </IonTabButton>
          <IonTabButton tab="tab2" href="/tab2">
            <IonIcon aria-hidden="true" icon={ellipse} />
            <IonLabel>Tab 2</IonLabel>
          </IonTabButton>
          <IonTabButton tab="tab3" href="/tab3">
            <IonIcon aria-hidden="true" icon={square} />
            <IonLabel>Tab 3</IonLabel>
          </IonTabButton>
        </IonTabBar>
      </IonTabs>
    </IonReactRouter>
  </IonApp>
);

export default App;
